import React from 'react';
import s from './Refollow.module.scss';

export default function RefollowSelectToolbar({
  selectMode,
  selectedCount,
  onStart,
  onCheckAll,
  onCheckPage,
  onCreate,
  onCancel,
  checkAllBusy,
}) {
  if (!selectMode) {
    return (
      <button type="button" className={s.refollowProminentBtn} onClick={onStart}>
        Follow up
      </button>
    );
  }

  return (
    <div className={s.refollowInlineGroup}>
      <span className={s.refollowSelectedLabel}>
        {selectedCount}
        {' selected'}
      </span>
      <button type="button" className={s.refollowInlineChip} disabled={checkAllBusy} onClick={onCheckAll}>
        {checkAllBusy ? 'Loading…' : 'Check all'}
      </button>
      <button type="button" className={s.refollowInlineChip} onClick={onCheckPage}>Check page</button>
      <button
        type="button"
        className={s.refollowInlineBtnPrimary}
        disabled={selectedCount === 0}
        onClick={onCreate}
      >
        Create follow-up
      </button>
      <button type="button" className={s.refollowInlineChip} onClick={onCancel}>Cancel</button>
    </div>
  );
}
